// @uifabric/styling@6.47.6
  // Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
  import { setVersion } from '@uifabric/set-version';
  setVersion('@uifabric/styling', '6.47.6');